import { useEffect, useState } from "react";
import axios from "axios";

const useProvinciasCiudades = (token, year, mes, idAdministrador) => {
  const [provinciasCiudades, setProvinciasCiudades] = useState([]);
  const [loading, setLoading] = useState(false); // Iniciar como false
  const [error, setError] = useState(null);

  useEffect(() => {
    // Solo iniciar la carga cuando tengamos valores válidos
    if (!token || !idAdministrador) {
      return; // Salir temprano si faltan datos críticos
    }
    
    setLoading(true); // Activar loading solo cuando vamos a hacer la petición
    
    const fetchProvinciasCiudades = async () => {
      try {
        const response = await axios.get(
          'https://seguimientoconductor-nodejs-pits.com/administrador_seginus/obtenerProvinciasCiudades',
          {
            params: { anio: year, mes: mes, id_administrador: idAdministrador },
            headers: { Authorization: token },
          }
        );
        
        if (response.data && response.data.success) {
          setProvinciasCiudades(response.data.data || []);
          setError(null);
        } else {
          setError(response.data?.message || "Respuesta sin datos");
          setProvinciasCiudades([]);
        }
      } catch (error) {
        console.error("Error al obtener provincias y ciudades:", error);
        setError(error.message || "Error de conexión");
        setProvinciasCiudades([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProvinciasCiudades();
    
  }, [token, year, mes, idAdministrador]);

  return { provinciasCiudades, loading, error };
};

export default useProvinciasCiudades;